(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brimar-comment-ca-marche"] && !Shopify.designMode) return;
  try {
    
  /*
    « Comment ça marche ? » en mode vidéo : au clic sur la couverture, la vidéo est insérée
    (une seule fois) et lancée avec le son dans le même geste, puis la fenêtre native d'Horizon
    s'ouvre — après définition du composant si le script dialog.js n'est pas encore chargé.
    À la fermeture (bouton, Échap, clic sur le fond), la vidéo est mise en pause.
  */
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element && event.target.closest('.brimar-hiw__play');
    if (!button) return;

    const component = button.closest('dialog-component');
    const player = component?.querySelector('.brimar-hiw__player');
    if (!component || !player) return;

    let video = player.querySelector('video');
    if (!video) {
      const source = player.querySelector('template')?.content.querySelector('video');
      if (!source) return;
      video = /** @type {HTMLVideoElement} */ (source.cloneNode(true));
      player.append(video);
    }

    video.muted = false;
    video.play().catch(() => {});

    customElements.whenDefined('dialog-component').then(() => {
      /** @type {any} */ (component).showDialog();
    });

    // Garde-fou : jamais de son sans fenêtre visible. Pause si elle n'est pas ouverte sous 1 s,
    // reprise dès son ouverture (événement natif dialog:open).
    const dialog = component.querySelector('dialog');
    window.setTimeout(() => {
      if (dialog?.open || video.paused) return;
      video.pause();
      component.addEventListener('dialog:open', () => video.play().catch(() => {}), { once: true });
    }, 1000);
  });

  document.addEventListener(
    'close',
    (event) => {
      if (!(event.target instanceof HTMLDialogElement)) return;
      if (!event.target.classList.contains('brimar-hiw__dialog')) return;
      event.target.querySelector('video')?.pause();
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brimar-dimensionnement-surface"] && !Shopify.designMode) return;
  try {
    
  class BrimarDimensionnementSurface extends HTMLElement {
    connectedCallback() {
      const raw = this.querySelector('[data-dims-data]');
      this.form = this.querySelector('[data-calc]');
      if (!raw || !this.form) return;
      try {
        this.data = JSON.parse(raw.textContent);
      } catch (e) {
        return;
      }
      this.data.main = (this.data.main || []).filter(Boolean);
      this.data.complement = (this.data.complement || []).filter(Boolean);
      if (!this.data.conso) return;

      this.lang = document.documentElement.lang || 'fr';
      this.form.addEventListener('submit', (e) => e.preventDefault());
      this.form.addEventListener('input', () => this.compute());
      this.compute();
    }

    surface() {
      const input = this.form.querySelector('[name="surface"]');
      const n = parseFloat(String(input?.value ?? '').replace(',', '.'));
      return Number.isFinite(n) && n > 0 ? n : 0;
    }

    fmt(n, digits = 1) {
      return Number(n).toLocaleString(this.lang, { maximumFractionDigits: digits });
    }

    /* Couverture d'un besoin avec des conditionnements en quantité libre : coût minimal, puis moins de contenants.
       Programmation dynamique sur des dixièmes d'unité (kg ou L). */
    cover(need, variants) {
      const usable = variants.filter((v) => v.available && v.q > 0);
      if (!usable.length) return null;
      const cap = Math.ceil(need * 10 - 1e-9);
      if (cap <= 0) return { items: [], cost: 0, count: 0, qty: 0 };
      const best = new Array(cap + 1).fill(null);
      best[0] = { cost: 0, count: 0, prev: -1, v: null };
      for (let x = 1; x <= cap; x++) {
        for (const v of usable) {
          const step = Math.round(v.q * 10);
          const from = Math.max(0, x - step);
          const b = best[from];
          if (!b) continue;
          const cand = { cost: b.cost + v.price, count: b.count + 1, prev: from, v };
          const cur = best[x];
          if (!cur || cand.cost < cur.cost || (cand.cost === cur.cost && cand.count < cur.count)) best[x] = cand;
        }
      }
      const end = best[cap];
      if (!end) return null;
      const counts = new Map();
      let x = cap;
      let qty = 0;
      while (x > 0 && best[x].v) {
        const v = best[x].v;
        counts.set(v.id, { v, n: (counts.get(v.id)?.n || 0) + 1 });
        qty += v.q;
        x = best[x].prev;
      }
      const items = [...counts.values()].sort((a, b) => b.v.q - a.v.q);
      return { items, cost: end.cost, count: end.count, qty };
    }

    compute() {
      const result = this.querySelector('[data-result]');
      const out = this.querySelector('[data-out]');
      const surface = this.surface();
      if (!surface) {
        result.setAttribute('data-empty', '');
        out.innerHTML = '';
        return;
      }
      result.removeAttribute('data-empty');

      const d = this.data;
      const need = surface * d.conso;
      const unit = d.unit;
      let plan = null;
      let message = null;

      if (d.complementConfigured) {
        // Une seule unité du produit courant, complément libre ; jamais plusieurs premiers équipements.
        const candidates = [];
        for (const v of d.main.filter((m) => m.available)) {
          const rest = need - v.q;
          if (rest <= 1e-9) {
            candidates.push({ main: v, comp: null, cost: v.price, count: 1, qty: v.q });
          } else if (d.complementPublished) {
            const c = this.cover(rest, d.complement);
            if (c) candidates.push({ main: v, comp: c, cost: v.price + c.cost, count: 1 + c.count, qty: v.q + c.qty });
          }
        }
        if (candidates.length) {
          candidates.sort((a, b) => a.cost - b.cost || a.count - b.count || b.main.q - a.main.q);
          plan = candidates[0];
        } else {
          message = d.main.some((m) => m.available) ? this.dataset.msgComplementUnavailable : this.dataset.msgMainUnavailable;
        }
      } else {
        const c = this.cover(need, d.main);
        if (c) plan = { main: null, comp: c, cost: c.cost, count: c.count, qty: c.qty };
        else message = this.dataset.msgMainUnavailable;
      }

      const esc = (t) => String(t).replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
      let html = `<p class="brimar-dims__for">${esc(this.forLabel(surface))}</p>`;
      html += `<p class="brimar-dims__row"><span class="brimar-dims__row-label">${esc(this.dataset.labelNeed)}</span><span class="brimar-dims__need">${this.fmt(need)}<small>${esc(unit)}</small></span></p>`;

      if (plan) {
        const lines = [];
        if (plan.main) lines.push(`<li class="brimar-dims__item"><span class="brimar-dims__qty">1 ×</span><span>${esc(d.labelMain)} ${esc(plan.main.title)}</span></li>`);
        if (plan.comp) {
          const label = plan.main ? d.labelComplement : d.labelMain;
          const url = plan.main ? d.complementUrl : null;
          for (const it of plan.comp.items) {
            const name = `${esc(label)} ${esc(it.v.title)}`;
            lines.push(`<li class="brimar-dims__item"><span class="brimar-dims__qty">${it.n} ×</span><span>${url ? `<a href="${esc(url)}">${name}</a>` : name}</span></li>`);
          }
        }
        html += `<div class="brimar-dims__row"><span class="brimar-dims__row-label">${esc(this.dataset.labelProposal)}</span><ul class="brimar-dims__list" role="list">${lines.join('')}</ul></div>`;
        html += `<p class="brimar-dims__row"><span class="brimar-dims__row-label">${esc(this.dataset.labelCovered)}</span><span class="brimar-dims__covered">${this.fmt(plan.qty)} ${esc(unit)}</span></p>`;
      } else if (message) {
        const link = d.complementConfigured && d.complementPublished && d.complementUrl
          ? `<br><a href="${esc(d.complementUrl)}">${esc(this.dataset.labelSee.replace('[produit]', d.labelComplement))}</a>`
          : '';
        html += `<p class="brimar-dims__msg">${esc(message)}${link}</p>`;
      }
      out.innerHTML = html;
    }

    forLabel(surface) {
      return (this.dataset.labelFor || 'Pour [surface] m²').replace('[surface]', this.fmt(surface, 2));
    }
  }

  if (!customElements.get('brimar-dimensionnement-surface')) {
    customElements.define('brimar-dimensionnement-surface', BrimarDimensionnementSurface);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brimar-dimensionnement"] && !Shopify.designMode) return;
  try {
    
  class BrimarDimensionnement extends HTMLElement {
    connectedCallback() {
      this.rendement = parseInt(this.dataset.rendement, 10) || 0;
      this.mode = this.dataset.mode === 'cavite' ? 'cavite' : 'surface';
      this.form = this.querySelector('[data-calc]');
      if (!this.form || !this.rendement) return;

      this.querySelectorAll('[data-mode-btn]').forEach((btn) => {
        btn.addEventListener('click', () => this.setMode(btn.dataset.modeBtn));
      });
      this.form.addEventListener('submit', (e) => e.preventDefault());
      this.form.addEventListener('input', () => this.compute());
      this.compute();
    }

    setMode(mode) {
      this.mode = mode === 'cavite' ? 'cavite' : 'surface';
      this.querySelectorAll('[data-mode-btn]').forEach((btn) => {
        btn.setAttribute('aria-selected', btn.dataset.modeBtn === this.mode ? 'true' : 'false');
      });
      this.querySelectorAll('[data-fields]').forEach((el) => {
        el.hidden = el.dataset.fields !== this.mode;
      });
      this.querySelectorAll('[data-intro]').forEach((el) => {
        el.hidden = el.dataset.intro !== this.mode;
      });
      this.compute();
    }

    value(name) {
      const input = this.form.querySelector(`[name="${name}"]`);
      const n = parseFloat(String(input?.value ?? '').replace(',', '.'));
      return Number.isFinite(n) && n > 0 ? n : 0;
    }

    /* Surface : m² × mm = L · Cavité : m × cm × cm ÷ 10 = L */
    compute() {
      const fields = this.mode === 'surface' ? ['surface', 'epaisseur'] : ['longueur', 'largeur', 'profondeur'];
      const values = fields.map((name) => this.value(name));
      const result = this.querySelector('[data-result]');

      // État neutre tant qu'un champ du mode actif est vide ou ≤ 0
      if (values.some((v) => v <= 0)) {
        result.setAttribute('data-empty', '');
        return;
      }
      result.removeAttribute('data-empty');

      const volume = this.mode === 'surface' ? values[0] * values[1] : (values[0] * values[1] * values[2]) / 10;
      const kits = Math.ceil(volume / this.rendement);

      this.querySelector('[data-volume]').textContent = this.formatVolume(volume);
      this.querySelector('[data-kits]').textContent = String(kits);
      this.querySelector('[data-kits-label]').textContent = kits === 1 ? this.dataset.labelOne : this.dataset.labelOther;
    }

    formatVolume(v) {
      const rounded = v >= 100 ? Math.round(v) : Math.round(v * 10) / 10;
      return rounded.toLocaleString(document.documentElement.lang || 'fr', { maximumFractionDigits: 1 });
    }
  }

  if (!customElements.get('brimar-dimensionnement')) {
    customElements.define('brimar-dimensionnement', BrimarDimensionnement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brimar-nav-produit"] && !Shopify.designMode) return;
  try {
    
  class BrimarNavProduit extends HTMLElement {
    connectedCallback() {
      this.links = Array.from(this.querySelectorAll('.brimar-nav__link[data-brimar-target]'));
      this.designMode = this.hasAttribute('data-design-mode');
      this.targets = new Map();

      this.links.forEach((link) => {
        const target = document.getElementById(link.dataset.brimarTarget);
        if (target) {
          this.targets.set(target, link);
        } else if (!this.designMode) {
          link.closest('.brimar-nav__item').hidden = true;
        }
      });

      this.updateOffset();
      this.resizeObserver = new ResizeObserver(() => this.updateOffset());
      this.resizeObserver.observe(this);
      window.addEventListener('resize', this.updateOffset);

      this.links.forEach((link) => link.addEventListener('click', this.onClick));

      if ('IntersectionObserver' in window && this.targets.size > 0) {
        this.observer = new IntersectionObserver(this.onIntersect, {
          rootMargin: '-45% 0px -50% 0px',
          threshold: 0,
        });
        this.targets.forEach((_, target) => this.observer.observe(this.sectionFor(target)));
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.observer?.disconnect();
      window.removeEventListener('resize', this.updateOffset);
    }

    /* La section Shopify qui contient l'ancre sert de zone d'observation */
    sectionFor(target) {
      return target.closest('.shopify-section') || target;
    }

    /* Décalage de défilement = header + hauteur de la barre, exposé aux ancres via scroll-margin-top */
    updateOffset = () => {
      /* Hauteur réelle du header collant (la variable --header-height d'Horizon ne reflète pas toujours
         la hauteur affichée) ; 0 si le header collant est désactivé */
      const headerVar = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
      const headerEl = document.querySelector('.header-section');
      let header = headerVar;
      if (headerVar > 0 && headerEl) {
        const headerStyle = getComputedStyle(headerEl);
        const stuckTop = headerStyle.position === 'sticky' ? parseFloat(headerStyle.top) || 0 : 0;
        header = Math.max(0, headerEl.getBoundingClientRect().height + stuckTop);
      }
      const sticky = this.classList.contains('brimar-nav--sticky');
      this.closest('.shopify-section')?.style.setProperty('--brimar-nav-top', `${header}px`);
      const offset = (sticky ? header + this.offsetHeight : 0) + 16;
      document.documentElement.style.setProperty('--brimar-anchor-offset', `${offset}px`);
    };

    onClick = (event) => {
      const target = document.getElementById(event.currentTarget.dataset.brimarTarget);
      if (!target) return;
      event.preventDefault();
      this.updateOffset();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', `#${target.id}`);
      this.setActive(event.currentTarget);
    };

    onIntersect = (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const target = entry.target.querySelector('[data-brimar-anchor]');
        const link = target && this.targets.get(target);
        if (link) this.setActive(link);
      });
    };

    setActive(link) {
      this.links.forEach((l) => {
        const active = l === link;
        l.closest('.brimar-nav__item').classList.toggle('brimar-nav__item--active', active);
        if (active) l.setAttribute('aria-current', 'location');
        else l.removeAttribute('aria-current');
      });
      /* Centre le lien actif dans la barre (utile sur mobile) */
      const scroller = this.querySelector('.brimar-nav__scroller');
      const left = link.offsetLeft - scroller.clientWidth / 2 + link.offsetWidth / 2;
      scroller.scrollTo({ left, behavior: 'smooth' });
    }
  }

  if (!customElements.get('brimar-nav-produit')) {
    customElements.define('brimar-nav-produit', BrimarNavProduit);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
